import { render, staticRenderFns } from "./CoachSelector.vue?vue&type=template&id=30b920de&lang=pug"
import script from "./CoachSelector.vue?vue&type=script&lang=js"
export * from "./CoachSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports